<template>
  <div class="banner-container">
    <div class="banner" :style="{ color: getContrastingColour() }" :class="{ info: type === 'info' }">
      <slot></slot>
    </div>
    <transition name="fade">
      <div class="overlay" v-if="showOverlay"></div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import { default as ColourPicker } from '@/shared/services/color';
import { PropType } from 'vue';

const props = defineProps({
  showOverlay: {
    type: Boolean,
  },
  type: {
    type: String as PropType<'warning' | 'info'>,
    default: 'warning',
  },
});

function getContrastingColour() {
  let bgColour = '#91B2ff';
  if (props.type === 'warning') {
    bgColour = '#E6C300';
  }
  return ColourPicker.getContrastingColour(bgColour);
}
</script>

<style scoped lang="scss">
.banner {
  position: fixed;
  top: 0;
  right: 0;
  left: 4.5rem;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1rem 2.5rem;
  z-index: 2;
  background-color: $color-netcall-jonquil;

  &.info {
    background-color: #91b2ff;
  }

  a {
    color: inherit;
  }
}

.banner-text {
  margin-right: 1rem;
}

.overlay {
  z-index: 1;
  background: #333;
  opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: opacity 500ms;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 500ms;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
